"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FireLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var FireLinear = function FireLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.698.034a.318.318 0 00-.324.022c-1.373.948-2.52 2.546-2.92 4.07-.278 1.062-.315 2.255-.32 3.043-1.269-.26-1.556-2.09-1.56-2.11a.302.302 0 00-.161-.224.32.32 0 00-.282-.004c-.067.03-1.633.798-1.724 3.863A4.907 4.907 0 002.4 9c0 2.977 2.512 5.4 5.6 5.4H4A.8.8 0 004 16h8a.8.8 0 100-1.6H8.016c3.08-.008 5.584-2.428 5.584-5.4 0-.15-.032-.569-.032-.569-.17-2.147-1.207-3.493-2.122-4.68-.848-1.1-1.58-2.05-1.58-3.45a.3.3 0 00-.168-.267zM7.82 9.886A2.8 2.8 0 018.36 8.8c.113.412.334.746.55 1.071.308.466.627.947.683 1.769.004.048.007.097.007.15 0 .998-.718 1.81-1.6 1.81-.882 0-1.6-.812-1.6-1.81v-.009c0-.031 0-.063.002-.101.01-.421.086-.709.169-.9.154.353.43.677.88.677a.275.275 0 00.267-.283c0-.403.008-.868.102-1.288z",
    fill: "currentColor"
  }));
};

exports.FireLinear = FireLinear;
var _default = FireLinear;
exports.default = _default;